import cx from 'clsx';
import React from 'react';
import { Tooltip } from 'react-tooltip';

import style from './style.module.scss';

export type TVariant = 'standard' | 'high' | 'critical' | 'archived' | 'success';

interface IProps {
  variant: TVariant;
  text: string;
  tooltipContent?: string;
  tooltipId?: string;
  className?: string;
}

const Label: React.FC<IProps> = ({ variant, text, tooltipContent, tooltipId, className }) => {
  return (
    <div
      className={cx(style.label, style[variant], className)}
      data-tooltip-id={tooltipId}
      data-tooltip-content={tooltipContent}
    >
      {text}
    </div>
  );
};

export default Label;
